export const ORDER_DETAIL_RETURN_ADDRESS_ID = 'return_address_order_instance'
export const ORDER_DETAIL_RECIPIENTS = 'recipients_order_instance'
